import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.914 11c-1.095 0-1.98.894-1.98 2 0 1.106.885 2 1.98 2s1.98-.894 1.98-2c0-1.106-.885-2-1.98-2Zm6.93 0c-1.095 0-1.98.894-1.98 2 0 1.106.885 2 1.98 2s1.98-.894 1.98-2c0-1.106-.885-2-1.98-2Zm6.93 0c-1.095 0-1.98.894-1.98 2 0 1.106.885 2 1.98 2s1.98-.894 1.98-2c0-1.106-.885-2-1.98-2Zm-6.93-11C7.095 0 .004 5.819.004 13c0 2.975 1.231 5.7 3.273 7.894-.922 2.462-2.84 4.55-2.87 4.575a1.511 1.511 0 0 0-.285 1.625c.235.55.773.906 1.367.906 3.805 0 6.806-1.606 8.607-2.894 1.788.569 3.719.894 5.748.894 8.75 0 15.84-5.819 15.84-13s-7.09-13-15.84-13Zm0 23c-1.652 0-3.285-.256-4.85-.756l-1.405-.45-1.207.862a13.258 13.258 0 0 1-3.558 1.813c.452-.757.891-1.607 1.232-2.513L6.71 20.2l-1.274-1.363c-1.12-1.206-2.463-3.2-2.463-5.837 0-5.513 5.773-10 12.87-10 7.097 0 12.87 4.487 12.87 10 0 5.512-5.773 10-12.87 10Z",
      fill: "#394053"
    }, null, -1)
  ]))]))
}
export default { render: render }